export default __webpack_public_path__ + "static/112-cf19018b031d02c430515651d024e67b.gif";